import { Category } from '../models/index';

const now = new Date().toISOString();
const mockStoreId = 'mock-store-id-12345';

export const MOCK_CATEGORIES: Category[] = [
  { id: 'CAT001', storeId: mockStoreId, name: 'Flower', createdAt: now },
  { id: 'CAT002', storeId: mockStoreId, name: 'Edibles', createdAt: now },
  { id: 'CAT003', storeId: mockStoreId, name: 'Gear', createdAt: now },
  { id: 'CAT004', storeId: mockStoreId, name: 'Pre-rolls', createdAt: now },
];
